import {
  MRC_ACCESSORY,
  MRC_BUYER,
  MRC_FABRIC,
  MRC_FABRIC_PART,
  MRC_GARMENT_ITEM,
  MRC_ITEM_CATEGORY,
  MRC_PROCESS,
  MRC_RATE_TYPE,
  MRC_SEASON,
  MRC_STYLE,
  MRC_TEAM,
} from '@constants/internal-route.constant'

// The feature urls under each sidebar group. A group renders only when the user holds at least one
// of them (SidebarMenuItemWithSub `anyOf`), so a role granted nothing in a group never sees an
// empty accordion. The groups follow the client's menu (Merchandising-Docs/Merchandising-menu.txt);
// the Merchandising and Reports groups arrive with the order, BOM, budget, booking, PI and TnA
// phases.

export const ADMIN_CONFIG_ROUTES = [MRC_TEAM]

export const ITEM_MASTER_ROUTES = [
  MRC_BUYER,
  MRC_ITEM_CATEGORY,
  MRC_FABRIC,
  MRC_ACCESSORY,
  MRC_STYLE,
  MRC_SEASON,
  MRC_GARMENT_ITEM,
  MRC_RATE_TYPE,
  MRC_FABRIC_PART,
  MRC_PROCESS,
]

/** Every screen in the console, in sidebar group order — the landing page's fallback list. */
export const ALL_ROUTES = [...ITEM_MASTER_ROUTES, ...ADMIN_CONFIG_ROUTES]
